"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleI18nDomainMappingV2ClientProvider = exports.CXTupleI18nDomainMappingV2Context = void 0;
var CXTupleI18nDomainMappingV2Context_1 = require("./CXTupleI18nDomainMappingV2Context");
Object.defineProperty(exports, "CXTupleI18nDomainMappingV2Context", { enumerable: true, get: function () { return __importDefault(CXTupleI18nDomainMappingV2Context_1).default; } });
var CXTupleI18nDomainMappingV2ClientProvider_1 = require("./CXTupleI18nDomainMappingV2ClientProvider");
Object.defineProperty(exports, "CXTupleI18nDomainMappingV2ClientProvider", { enumerable: true, get: function () { return __importDefault(CXTupleI18nDomainMappingV2ClientProvider_1).default; } });
